import { render, staticRenderFns } from "./chooseResourceStore2.vue?vue&type=template&id=3a53fb93&scoped=true"
import script from "./chooseResourceStore2.vue?vue&type=script&lang=js"
export * from "./chooseResourceStore2.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStore2.vue?vue&type=style&index=0&id=3a53fb93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53fb93",
  null
  
)

export default component.exports